import React, { FC } from 'react';
import { Trans } from '@lingui/macro';

import { Flex } from '@rover/kibble/core';
import { FontSize, MQ, Spacing } from '@rover/kibble/styles';
import { useTheme } from '@rover/kibble/themes';

// i18n config has been removed for the duration of the React Mobile Homepage Experiment
// DEV-31261 will investigate a better solution that will allow us to re-enable translations here,
// which will involve just moving the date back into the Trans tag.
const Copyright: FC = () => {
  const theme = useTheme();

  return (
    <Flex
      height="48px"
      justifyContent="left"
      width="100%"
      color={theme.colors.text.tertiary.toString()}
      background="secondary"
      alignItems="center"
      sx={{
        [MQ.SM.toString()]: {
          justifyContent: 'center',
        },
        [MQ.XS.toString()]: {
          marginTop: Spacing.L.toString(),
          height: '74px',
        },
        fontSize: FontSize.S.toString(),
      }}
    >
      <Flex
        as="span"
        sx={{
          [MQ.XS.toString()]: {
            marginBottom: Spacing.S.toString(),
          },
          [MQ.NOT_XS.toString()]: {
            marginRight: Spacing.XS.toString(),
          },
        }}
      >
        © {`${new Date().getFullYear()} `}{' '}
        <Trans>A Place for Rover, Inc. All Rights Reserved.</Trans>
      </Flex>
    </Flex>
  );
};

export default Copyright;
